/**
 * Carry the jobs index filters onto a job so the next and previous arrows
 * stay inside that list. A direct visit has no `jobList` param and uses the full list.
 */

/**
 * @param {object} [queryParams] Query the jobs index is already using.
 * @returns {string} `?jobList=...` or an empty string when there is nothing to carry.
 */
export function jobListSearch(queryParams) {
  const listQuery = { ...(queryParams || {}) };
  delete listQuery.page;
  delete listQuery.limit;

  const entries = Object.entries(listQuery).filter(([, value]) => {
    if (value === undefined || value === null || value === "" || value === false) {
      return false;
    }
    return true;
  });
  if (!entries.length) return "";

  const params = new URLSearchParams();
  params.set("jobList", JSON.stringify(Object.fromEntries(entries)));
  return `?${params.toString()}`;
}

/**
 * @param {string} [search]
 * @returns {object}
 */
export function readJobListQuery(search) {
  const raw = new URLSearchParams(search || "").get("jobList");
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const query = { ...parsed };
    delete query.page;
    delete query.limit;
    return query;
  } catch {
    return {};
  }
}
